import { React } from 'libs/react';
import './LazyLoadFallback.scss';
/**
 * @component LazyLoadFallback
 * @description Fallback component shown while lazy-loading routes
 * @since 1.0.0
 */
export function LazyLoadFallback() {
    return (React.createElement("div", { className: "lazy-load-fallback" },
        React.createElement("div", { className: "lazy-load-spinner" })));
}
